import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import React, { useEffect } from 'react'

import { usePageTitle } from '../context/PageTitleContext'

const DetailPageTemplate = ({
  title,
  isLoading,
  actions,
  sections,
  dialogs,
  breadcrumbs,
}) => {
  const { setBreadcrumbs } = usePageTitle()

  useEffect(() => {
    if (!breadcrumbs?.length) return
    setBreadcrumbs(breadcrumbs)

    return () => {
      setBreadcrumbs([])
    }
  }, [JSON.stringify(breadcrumbs), setBreadcrumbs])

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Stack
      sx={{
        padding: 2,
        margin: 'auto',
        maxWidth: 'lg',
        flexGrow: 1,
      }}
    >
      <Stack width={'100%'} spacing={3}>
        <Box
          position="sticky"
          top={0}
          zIndex="appBar"
          bgcolor="background.default"
        >
          <Stack
            flexDirection={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            py={2}
          >
            <Typography variant="h5" component="h1">
              {title}
            </Typography>
            <Box>{actions}</Box>
          </Stack>
          <Divider />
        </Box>

        <Grid container size={12} spacing={3}>
          {sections.map((section, index) => (
            <Grid
              container
              direction={'column'}
              key={section.title || index}
              size={12}
              maxWidth={'lg'}
              px={1}
            >
              {section.title && (
                <Typography variant="h6" component="h2" gutterBottom>
                  {section.title}
                </Typography>
              )}
              {section.content}
            </Grid>
          ))}
        </Grid>
      </Stack>

      {dialogs}
    </Stack>
  )
}

export default DetailPageTemplate
